import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { Subscription, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { CarrelloService } from '../../_services/carrello.service';
import { HeaderService, HeaderDettaglioScheda } from '../../_services/header.service';
import { StorageService } from '../../_services/storage.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: []
})
export class HeaderComponent implements OnInit, OnDestroy {

  constructor(
    private service: HeaderService, 
    private carrelloService: CarrelloService,
    private router: Router,
    private localize: LocalizeRouterService
    ) { }

  @Output() menuOpen = new EventEmitter<void>();
  @Output() menuOpenIndex = new EventEmitter<void>();

  subscriptions: Subscription[] = [];

  totaleCarrello = 0;
  termineRicerca = '';


  ngOnInit() {
    this.aggiornaTotaleCarrello();

    this.subscriptions.concat([
      this.service.aggiornaCarrello.subscribe(() => this.aggiornaTotaleCarrello() )
    ]);

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  aggiornaTotaleCarrello() {
    this.totaleCarrello = 0;
    this.carrelloService.getProdotti().subscribe(prodotti => prodotti.forEach(p => this.totaleCarrello += p.quantita));
  }

  cerca() {
    if (this.termineRicerca) {
      this.router.navigate([this.localize.translateRoute('/ricerca-generica')], { queryParams: { q: this.termineRicerca } });
    }
  }

}
